
//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'
import { Data as OtherContent } from '../listenKey/index'

//共用
import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'
import { Data as AccountContent } from '../spot/api/account/index'
import { Data as WalletContent } from '../spot/api/wallet/index'


import Introduce from './1_introduce.json'
import { Data as PermissionContent } from './api/permission/index'
import { Data as SubAccount } from './api/subAccount/index'



let aaa = JSON.stringify(OtherContent)
aaa = aaa.replaceAll("/market/<listenKey>", "/market?listenKey==")
aaa = aaa.replaceAll("wss://open-api-ws.bingx.com/market?listenKey=", "wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")

const ROOT_MODULE = "en-us/common"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "Frequently Asked Questions",
  "content": QandAContent
}

export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket API Reference",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "Change Log",
  "content": ChangeLogContent
}
const SubAccountContent = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/sub-account`,
  "name": "Sub-account management",
  "content": SubAccount
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "Authentication",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "General Info",
  "content": BasicContent
}
const Account = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/account-api.html`,
  "name": "Account assets",
  "content": AccountContent
}
const Wallet = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/wallet-api.html`,
  "name": "Wallet deposits and withdrawals",
  "content": WalletContent
}
// const Permission = {
//   "module": ROOT_MODULE,
//   "path": `/${ROOT_MODULE}/permission-interface.html`,
//   "name": "permission interface",
//   "content": PermissionContent
// }
const Auth = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication-interface.html`,
  "name": "Authentication Interface",
  "content": JSON.parse(aaa)
}


export const commonConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  // Permission,
  Account,
  Wallet,
  SubAccountContent,
  Auth,
]


// WEBPACK FOOTER //
// ./src/config/en-US/common/index.js